import { Text } from '@airwallex/typography';
import React, { useMemo } from 'react';
import { formatCurrency } from '@airwallex/awx-currency-formatter';
import { VStack } from '@airwallex/stacks';
import { TotalRow, Divider } from './v1/style';
import { Trans, useTranslation } from 'react-i18next';
import { useTabletOrMobile } from '@/hooks/useMediaQuery';
import { CreditNoteDetail } from '../types';
import DiscountRows from '@/components/common/DiscountRows';

type Props = {
  creditNote: CreditNoteDetail;
};

const TotalSection: React.FC<Props> = ({ creditNote }) => {
  const { t } = useTranslation();
  const { subtotalAmount, totalAmountExcludeTax, totalAmount, totalTaxAmount, currency, taxPercent } = creditNote;
  const isTabletOrMobile = useTabletOrMobile();

  return (
    <VStack
      data-test="credit-note-total-section"
      space="12px"
      style={{ margin: '0 8px', paddingLeft: isTabletOrMobile ? 8 : '50%', paddingRight: 8 }}
    >
      <TotalRow>
        <Text variant="body">{t('creditNote.subtotal')}</Text>
        <Text variant="body">
          {formatCurrency({
            amount: subtotalAmount,
            currency,
            showSymbol: true,
            showCode: false,
          })}
        </Text>
      </TotalRow>
      <DiscountRows discounts={creditNote.discounts} currency={currency} variant="row" />
      {creditNote.discounts && creditNote.discounts.length > 0 && typeof totalAmountExcludeTax === 'number' ? (
        <TotalRow>
          <Text variant="body">{t('creditNote.totalExcludingTax')}</Text>
          <Text variant="body">
            {formatCurrency({
              amount: totalAmountExcludeTax,
              currency,
              showSymbol: true,
              showCode: false,
            })}
          </Text>
        </TotalRow>
      ) : null}
      <TotalRow>
        <Text variant="body">
          <Trans i18nKey="invoice.tax.percentage" t={t} values={{ percentage: taxPercent }} />
        </Text>
        <Text variant="body">
          {formatCurrency({
            amount: totalTaxAmount,
            currency,
            showSymbol: true,
            showCode: false,
          })}
        </Text>
      </TotalRow>
      <TotalRow>
        <Divider />
      </TotalRow>
      <TotalRow>
        <Text variant="headline300">{t('creditNote.total', { currency })}</Text>
        <Text variant="headline300">
          {formatCurrency({
            amount: totalAmount,
            currency,
            showSymbol: true,
            showCode: false,
          })}
        </Text>
      </TotalRow>
    </VStack>
  );
};

export default TotalSection;
